import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { canAccess, type RouteKey, type AdminRole } from '@/types/rbac';

interface RoleGuardProps {
  /** The route key to check permissions for */
  route: RouteKey;
  children: React.ReactNode;
}

/**
 * Prevents access to a page if the user's role doesn't have
 * at least READ permission for the given route key.
 * Redirects to / (dashboard) which is always accessible.
 */
export function RoleGuard({ route, children }: RoleGuardProps) {
  const role = useAuthStore((s) => s.user?.role) as AdminRole | undefined;

  if (!role || !canAccess(role, route)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
